import { motion } from "framer-motion";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { DateOfBirthField } from "@/modules/onboarding/components/DateOfBirthField/DateOfBirthField";
import { MobileViewportContainer } from "@/modules/onboarding/components/MobileViewportContainer/MobileViewportContainer";
import { OnboardingBackButton } from "@/modules/onboarding/components/OnboardingBackButton/OnboardingBackButton";
import OnboardingHeaderV3 from "@/modules/onboarding/components/OnboardingScreenHeader/OnboardingHeaderV3";
import { updateUserIfAuthenticated } from "@/modules/onboarding/utils/updateUserIfAuthenticated";
import { useUser } from "@/modules/user/useUser/useUser";
import { Button } from "atoms/button/Button";
import { TextButton } from "atoms/text-button/TextButton";

const V3DateOfBirthPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const [dobIso, setDobIso] = useState<string | null>(
    user?.dateOfBirth ?? null
  );
  const [isValid, setIsValid] = useState<boolean>(false);

  useEffect(() => {
    if (user?.dateOfBirth) {
      setDobIso(user.dateOfBirth);
    }
  }, [user?.dateOfBirth]);

  const handleContinue = useCallback(async () => {
    if (dobIso) {
      await updateUserIfAuthenticated({ dateOfBirth: dobIso });
    }

    navigate("/signin/gender");
  }, [dobIso, navigate]);

  const handleSkip = useCallback(() => {
    navigate("/signin/gender");
  }, [navigate]);

  return (
    <MobileViewportContainer
      header={<OnboardingBackButton prev="/signin/email" />}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        className="flex w-full max-w-sm flex-col gap-9"
      >
        <OnboardingHeaderV3
          title="Your birthday deserves to be celebrated — when is it?"
          subtitle="We’ll honor it with a bespoke gift."
          align="left"
        />
        <div className="flex flex-col gap-3">
          <DateOfBirthField
            value={dobIso || undefined}
            onChange={setDobIso}
            onValidationChange={setIsValid}
            label="Enter your birthday"
            className="!ring-0 focus:!ring-0"
            labelClassName="hidden"
          />
          <div className="mt-6 flex flex-col items-center gap-4">
            <Button fullWidth onClick={handleContinue} disabled={!isValid}>
              Confirm
            </Button>
            <TextButton className="px-3 font-normal" onClick={handleSkip}>
              Choose not to share
            </TextButton>
          </div>
        </div>
      </motion.div>
    </MobileViewportContainer>
  );
};

export default V3DateOfBirthPage;
